import FieldTypes from './ExtendedFieldTypes';
var ValidatorType = /*#__PURE__*/function (ValidatorType) {
  ValidatorType["StringLengthValidator"] = "{83E96D09-11C8-4132-8A8A-76D8DB8208D6}";
  return ValidatorType;
}(ValidatorType || {});
export var validateField = function validateField(fieldValue, fieldModel, formDictionaries, confirmValue) {
  var maxFileSize = fieldModel.maxFileSize;
  var validationDataModels = fieldModel.validationDataModels;
  var required = fieldModel.required;
  var validationResult = {
    isValid: true,
    error: Array()
  };
  if ((!fieldValue || fieldValue.length === 0) && required === true) {
    validationResult.isValid = false;
    var requiredMessage = retrieveDataFromDictionary(formDictionaries, 'Required validation Message');
    requiredMessage = requiredMessage.phrase.replace('{0}', fieldModel.title);
    validationResult.error.push(requiredMessage);
  }
  if (validationDataModels && validationResult.isValid) {
    validationDataModels.forEach(function (validator) {
      var paramtersRegex = validator.parameters;
      if (typeof paramtersRegex === 'string' && paramtersRegex.length > 0) {
        var regularData = JSON.parse(paramtersRegex);
        paramtersRegex = regularData.regularExpression;
      }
      if (paramtersRegex && paramtersRegex != '^$') {
        var regex = new RegExp(paramtersRegex, 'gi');
        var match = fieldValue.match(regex);
        if (!required && fieldValue.length > 0 || required) {
          validationResult.isValid = match === null ? false : true;
          if (!validationResult.isValid) validationResult.error.push(validator.message.replace('{0}', fieldModel.title));
        }
      }
    });
  }
  var stringValidator = exportDataModel(validationDataModels, ValidatorType.StringLengthValidator);
  if (fieldModel.maxLength !== 0 && fieldValue.length > fieldModel.maxLength && stringValidator && validationResult.isValid) {
    validationResult.isValid = false;
    var message = stringValidator.message.replace('{0}', fieldModel.name).replace('{1}', fieldModel.minLength).replace('{2}', fieldModel.maxLength);
    validationResult.error.push(message);
  }
  if (fieldModel.fieldTypeItemId === FieldTypes.FileUpload && validationResult.isValid) {
    if (fieldValue.length > fieldModel.maxFileCount) {
      var maximumCountErrorMessage = retrieveDataFromDictionary(formDictionaries, 'fileCount');
      maximumCountErrorMessage = maximumCountErrorMessage.phrase.replace('{0}', fieldModel.maxFileCount).replace('{1}', fieldValue.length);
      validationResult.isValid = false;
      validationResult.error.push(maximumCountErrorMessage);
    }
    for (var x = 0; x < fieldValue.length; x++) {
      var currentFile = Array.isArray(fieldValue) ? fieldValue[x] : fieldValue.item(x);
      if (!currentFile) continue;
      if (fieldModel.allowedContentTypes.length > 0 && fieldModel.allowedContentTypes.indexOf(currentFile.type) === -1) {
        var typeErrorMessage = retrieveDataFromDictionary(formDictionaries, 'fileType');
        typeErrorMessage = typeErrorMessage.phrase.replace('{0}', currentFile.type).replace('{1}', currentFile.name);
        validationResult.isValid = false;
        validationResult.error.push(typeErrorMessage);
      }
      var isValid = currentFile.size <= fieldModel.maxFileSize * 1024;
      if (!isValid) {
        var maximumSizeErrorMessage = retrieveDataFromDictionary(formDictionaries, 'fileSize');
        maximumSizeErrorMessage = maximumSizeErrorMessage.phrase.replace('{0}', "".concat(fieldModel.maxFileSize, " KB")).replace('{1}', "".concat(Math.round(currentFile.size / 1024), " KB")).replace('{2}', currentFile.name);
        validationResult.isValid = false;
        validationResult.error.push(maximumSizeErrorMessage);
      }
    }
  }
  var isNotConfirmed = confirmValue !== null && fieldValue !== confirmValue;
  if (isNotConfirmed && validationResult.isValid) {
    validationResult.isValid = false;
  }
  if (fieldModel.fieldTypeItemId === '{50BC7E56-4660-4839-8408-1AFC7BC02E5B}') {
    var regex = new RegExp(fieldModel.regularExpression);
    if (fieldValue !== '') {
      if (!fieldValue.match(regex)) {
        var _requiredMessage = retrieveDataFromDictionary(formDictionaries, 'Regular expression validation message');
        _requiredMessage = _requiredMessage && _requiredMessage.phrase;
        validationResult.isValid = false;
        validationResult.error.push(_requiredMessage);
        // validationResult.error.push([]);
      }
    }
  }
  return validationResult;
};
export var retrieveDataFromDictionary = function retrieveDataFromDictionary(dictionaries, key) {
  if (typeof dictionaries === 'undefined' || !dictionaries) return null;
  for (var index = 0; index < dictionaries.length; index++) {
    if (dictionaries[index].key === key) return dictionaries[index];
  }
  return null;
};
var exportDataModel = function exportDataModel(validationDataModels, key) {
  for (var index = 0; index < validationDataModels.length; index++) {
    if (validationDataModels[index].itemId === key) return validationDataModels[index];
  }
  return null;
};